// extracted by mini-css-extract-plugin
export var button8 = "button8-module--button8--8aa8a";
export var primary = "button8-module--primary--6b494";
export var secondary = "button8-module--secondary--713ac";